<aca-alert-message #alertComponent></aca-alert-message>

<div class="disclaimBackground">
    <aca-disclaimer [adminMode]="adminMode"></aca-disclaimer>
</div>
